import { lazy } from "react";
import { useRoutes } from "react-router-dom";
import publicRoutes from "./modules/publicRoutes";
import workspaceHomeRoutes from "./modules/workspaceHome";
import financeManagerRoutes from "./modules/financeManager";
import homeManagerRoutes from "./modules/homeManager";
import goalManagerRoutes from "./modules/goalManager";
import configRoutes from "./modules/configRoutes";
import TenantGuard from "../contexts/TenantContext";
import LegacyModuleRedirect from "./LegacyModuleRedirect";
import { LEGACY_MODULE_PATHS, MODULE_PATHS } from "../utils/moduleConfig";

const ComingSoon = lazy(() => import("../components/organisms/ComingSoon"));
const JoinPage = lazy(() =>
  import("../Modules/Authentication/Page/JoinPage")
);
const OnboardingPage = lazy(() =>
  import("../Modules/Onboarding/OnboardingPage")
);

const AppRouter = () => {
  return useRoutes([
    // ─── Public routes (no tenant prefix) ────────────────────────────────
    ...publicRoutes,
    {
      path: "/join/:token",
      element: <JoinPage />,
    },

    // ─── Tenant-scoped routes: /:tenantSlug/* ────────────────────────────
    {
      path: "/:tenantSlug",
      element: <TenantGuard />,
      children: [
        {
          path: `${LEGACY_MODULE_PATHS.financeManager}/*`,
          element: (
            <LegacyModuleRedirect nextPrefix={MODULE_PATHS.financeManager} />
          ),
        },
        {
          path: `${LEGACY_MODULE_PATHS.homeManager}/*`,
          element: <LegacyModuleRedirect nextPrefix={MODULE_PATHS.homeManager} />,
        },
        {
          path: `${LEGACY_MODULE_PATHS.goalManager}/*`,
          element: <LegacyModuleRedirect nextPrefix={MODULE_PATHS.goalManager} />,
        },
        { path: "onboarding", element: <OnboardingPage /> },
        workspaceHomeRoutes,
        financeManagerRoutes,
        homeManagerRoutes,
        goalManagerRoutes,
        configRoutes,
      ],
    },

    { path: "*", element: <ComingSoon /> },
  ]);
};

export default AppRouter;
